/* tslint:disable */

declare var Object: any;
export interface PaymentReversalMemoInterface {
  "memo": string;
  "user_id": number;
  "tenant_payment_id": number;
  "lease_id": number;
  "id"?: number;
}

export class PaymentReversalMemo implements PaymentReversalMemoInterface {
  "memo": string;
  "user_id": number;
  "tenant_payment_id": number;
  "lease_id": number;
  "id": number;
  constructor(data?: PaymentReversalMemoInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PaymentReversalMemo`.
   */
  public static getModelName() {
    return "PaymentReversalMemo";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PaymentReversalMemo for dynamic purposes.
  **/
  public static factory(data: PaymentReversalMemoInterface): PaymentReversalMemo{
    return new PaymentReversalMemo(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PaymentReversalMemo',
      plural: 'PaymentReversalMemos',
      path: 'PaymentReversalMemos',
      idName: 'id',
      properties: {
        "memo": {
          name: 'memo',
          type: 'string'
        },
        "user_id": {
          name: 'user_id',
          type: 'number'
        },
        "tenant_payment_id": {
          name: 'tenant_payment_id',
          type: 'number'
        },
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
